
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { MensajeAlertaDanger } from "../../components";
import { separadorMillares } from "../../../hooks";
import { LayoutTabla } from "../../layouts";
import { fechaConHora } from "../../../helpers/prepararFecha";





export const TablaAbonosFactura = ({ data }) => {


    return (
        <>
        {(data?.length > 0)
        ?   <>
            <LayoutTabla>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'20%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'20%'}}>Valor</TableCell>
                        <TableCell sx={{width:'15%'}}>Medio</TableCell>
                        <TableCell sx={{width:'25%'}}>Observación</TableCell>
                        <TableCell sx={{width:'20%'}}>Acciones</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                {data.map((a) => (
                    <TableRow  key={ a._id }>
                        <TableCell>{ fechaConHora(a.createdAt) }</TableCell>
                        <TableCell>{ `$${separadorMillares(a.valor)}` }</TableCell>
                        <TableCell>{ a.medio }</TableCell>
                        <TableCell>{ a.observacion }</TableCell>

                        <TableCell>
                            {/* <IconButton className="icon-boton" >
                                <PageviewIcon fontSize="small" />
                            </IconButton> */}
                        </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </LayoutTabla>
            </>   

        :   <MensajeAlertaDanger titulo='No hay abonos disponibles' />
        }
        </>
    )
}
